import type { MutableRefObject, RefCallback } from 'react';
import { useMemo } from 'react';

export const useMergeRefs = <T>(...refs: Array<MutableRefObject<T | null> | RefCallback<T> | undefined | null>): RefCallback<T> =>
  useMemo<RefCallback<T>>(
    () => (value) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(value);
          return;
        }

        if (ref != null) {
          ref.current = value;
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs,
  );
